'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Subdivision

function Subdivision(_ref) {
  var title = _ref.title,
      imageUrl = _ref.imageUrl,
      pageUrl = _ref.pageUrl;

  return _react2.default.createElement(
    'div',
    { className: 'campaign-box', style: { backgroundImage: 'url(' + imageUrl + ')' } },
    _react2.default.createElement(
      _reactRouter.Link,
      { to: pageUrl },
      _react2.default.createElement(
        'p',
        null,
        title
      )
    )
  );
}

Subdivision.propTypes = {
  title: _react.PropTypes.string.isRequired,
  imageUrl: _react.PropTypes.string.isRequired,
  pageUrl: _react.PropTypes.string.isRequired
};

exports.default = Subdivision;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Subdivision.js
// module id = 1226
// module chunks = 0